<template>
  <div v-if="!!src">
    <!--<img v-if="isLazy" :data-src="src" :alt="alt" class="lazy img-cover">-->
    <img v-if="isProductImg" :src="src" :alt="alt" :class="[imgClass, 'img-cover']">
    <!--
    <no-ssr>
    <noscript>
      <img :src="src" :alt="alt">
    </noscript>
    </no-ssr>
    -->
  </div>
</template>

<script>
  export default {
    props: {
      src:String,
      alt: {
        type: String,
        default: ''
      },
      isLazy:Boolean,
      imgClass: String
    },
    computed: {
      isProductImg() {
        return this.src !== '/public/image-error.png';
      },
    },
  }
</script>

<style src="./style.scss" lang="scss" scoped/>



